// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"7cd3d5d2","172":"43d5ac69","197":"bc88f24d","381":"82d4363b","551":"3fa9154e","588":"08724103","617":"1aa9de26","619":"be073529","639":"24a9e885","906":"b74e5023","908":"c749333a"}[chunkId] + ".chunk.js";
};